import { GoogleIcon } from '@dd3tech/wiggui/GoogleIcon'

import { TraficLevel, WalkabilityLevel } from './enums'

export const WALKABILITY_LEVELS = {
  [WalkabilityLevel.WALKERS_PARADISE]: {
    color: '#5DD980',
    title: 'Paraíso peatonal',
    description:
      'Puedes realizar tus actividades diarias caminando en 15 minutos.',
    icon: (
      <GoogleIcon
        name="directions_run"
        className="text-[#5DD980] text-[30px]"
      />
    )
  },
  [WalkabilityLevel.WALKABLE]: {
    color: '#1B9FFF',
    title: 'Muy caminable',
    description:
      'Puedes caminar con tranquilidad. En ocasiones puntuales necesitas otro medio de transporte.',
    icon: (
      <GoogleIcon
        name="directions_walk"
        className="text-[#1B9FFF] text-[30px]"
      />
    )
  },
  [WalkabilityLevel.SOMEWHAT_WALKABLE]: {
    color: '#E8BC7A',
    title: 'Algo caminable',
    description:
      'Puedes caminar pero puede que sea complicado. Muchas veces necesitas otro medio de transporte.',
    icon: <GoogleIcon name="commute" className="text-[#E8BC7A] text-[30px]" />
  },
  [WalkabilityLevel.CAR_DEPENDENT]: {
    color: '#FF0000',
    title: 'Dependencia del auto',
    description:
      'Dependes de un auto, taxi, o transporte público para poder realizar tus actividades diarias.',
    icon: (
      <GoogleIcon
        name="directions_car"
        className="text-[#FF0000] text-[30px]"
      />
    )
  }
} as const

export const MIN_HOUR = 9
export const MAX_HOUR = 22

export const TRAFFIC_CATEGORIES = {
  [TraficLevel.FLUID]: {
    color: '#5DD980',
    iconClass: 'text-[#5DD980]',
    title: 'Tráfico fluido',
    iconCount: 1
  },
  [TraficLevel.MODERATE]: {
    color: '#1B9FFF',
    iconClass: 'text-[#1B9FFF]',
    title: 'Tráfico moderado',
    iconCount: 2
  },
  [TraficLevel.HEAVY]: {
    color: '#E8BC7A',
    iconClass: 'text-[#E8BC7A]',
    title: 'Tráfico congestionado',
    iconCount: 3
  },
  [TraficLevel.VERY_HEAVY]: {
    color: '#FF0000',
    iconClass: 'text-[#FF0000]',
    title: 'Tráfico intenso',
    iconCount: 4
  }
} as const
